/*
 * Client-side translation for the Seal Subscriptions widget.
 *
 * Seal renders its selling-plan names, option labels, savings badge and
 * description in the browser from its own JS, so these strings are NOT reachable
 * by Shopify's Translations API (and not by the `cmd/translate` tool). This file
 * replaces them in the DOM after the widget loads, using a fixed per-locale
 * dictionary so quality/voice stay controlled (no machine translation at runtime).
 *
 * Source language is German (de). The target is taken from Shopify.locale:
 *   - "de"                -> left untouched (source)
 *   - a locale we have    -> translated
 *   - missing/unsupported -> English (the international default)
 *
 * The dictionaries were generated through the same translation pipeline as the
 * rest of the store (internal/apps/translate), so register and terminology match.
 * To regenerate after changing the German strings, re-run cmd/sealgen.
 *
 * Each entry maps the exact German string to its translation. To add a language,
 * add a block keyed by the 2-letter locale.
 */
(function () {
  "use strict";

  var TRANSLATIONS = {
    cs: {
      "30-Tage-Lieferung": "30denní doručení",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30denní doručení + úložná dóza zdarma",
      "Lieferung jeden": "Doručení každý",
      "Monat": "měsíc",
      "SPARE 10%": "UŠETŘETE 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Aby byl Váš kůň trvale zaopatřen: Doručení každý měsíc se slevou 10 %. Lze kdykoliv pozastavit nebo upravit. Navíc ZDARMA získáte naši úložnou dózu."
    },
    da: {
      "30-Tage-Lieferung": "30-dages levering",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-dages levering + gratis opbevaringsbøtte",
      "Lieferung jeden": "Levering hver",
      "Monat": "Måned",
      "SPARE 10%": "SPAR 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Så din hest altid er dækket ind: Levering hver måned med 10 % rabat. Kan til enhver tid sættes på pause eller tilpasses. Derudover får du vores opbevaringsbøtte GRATIS."
    },
    el: {
      "30-Tage-Lieferung": "Παράδοση 30 ημερών",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "Παράδοση 30 ημερών + Δωρεάν δοχείο αποθήκευσης",
      "Lieferung jeden": "Παράδοση κάθε",
      "Monat": "μήνα",
      "SPARE 10%": "ΚΕΡΔΙΣΕ 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Για τη συνεχή φροντίδα του αλόγου σου: Παράδοση κάθε μήνα με έκπτωση 10%. Μπορείς να κάνεις παύση ή να την προσαρμόσεις ανά πάσα στιγμή. Επιπλέον, παίρνεις ΔΩΡΕΑΝ το δοχείο αποθήκευσής μας."
    },
    en: {
      "30-Tage-Lieferung": "30-day delivery",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-day delivery + free storage container",
      "Lieferung jeden": "Delivery every",
      "Monat": "month",
      "SPARE 10%": "SAVE 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "To ensure a continuous supply for your horse: delivery every month with a 10% discount. Pause or adjust at any time. Plus, you get our storage container for FREE."
    },
    es: {
      "30-Tage-Lieferung": "Entrega cada 30 días",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "Entrega cada 30 días + Bote de almacenamiento gratis",
      "Lieferung jeden": "Entrega cada",
      "Monat": "mes",
      "SPARE 10%": "AHORRA UN 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Para que tu caballo esté siempre bien atendido: entrega cada mes con un 10 % de descuento. Puedes pausarla o modificarla en cualquier momento. Además, recibirás GRATIS nuestro bote de almacenamiento."
    },
    et: {
      "30-Tage-Lieferung": "30-päevane tarne",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-päevane tarne + tasuta säilituskarp",
      "Lieferung jeden": "Tarne iga",
      "Monat": "kuu",
      "SPARE 10%": "SÄÄSTA 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Selleks, et sinu hobune oleks püsivalt varustatud: tarne iga kuu 10% soodustusega. Igal ajal peatatav või muudetav. Lisaks saad TASUTA meie säilituskarbi."
    },
    fi: {
      "30-Tage-Lieferung": "30 päivän toimitus",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30 päivän toimitus + ilmainen säilytysrasia",
      "Lieferung jeden": "Toimitus joka",
      "Monat": "kuukausi",
      "SPARE 10%": "SÄÄSTÄ 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Jotta hevosesi jatkuva tuki on taattu: toimitus joka kuukausi 10 % alennuksella. Tilauksen voi tauottaa tai sitä voi muokata milloin tahansa. Lisäksi saat ILMAISEN säilytyspurkkimme."
    },
    fr: {
      "30-Tage-Lieferung": "Livraison 30 jours",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "Livraison 30 jours + Boîte de conservation gratuite",
      "Lieferung jeden": "Livraison chaque",
      "Monat": "mois",
      "SPARE 10%": "ÉCONOMISE 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Pour que ton cheval bénéficie d'un apport continu : livraison chaque mois avec 10 % de réduction. Tu peux mettre en pause ou modifier à tout moment. En plus, tu reçois GRATUITEMENT notre boîte de conservation."
    },
    hr: {
      "30-Tage-Lieferung": "30-dnevna dostava",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-dnevna dostava + Gratis posuda za pohranu",
      "Lieferung jeden": "Isporuka svaki",
      "Monat": "mjesec",
      "SPARE 10%": "UŠTEDI 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Kako bi tvoj konj bio dugoročno opskrbljen: isporuka svaki mjesec uz 10 % popusta. Može se pauzirati ili prilagoditi u bilo kojem trenutku. Uz to GRATIS dobivaš našu posudu za čuvanje."
    },
    hu: {
      "30-Tage-Lieferung": "30 napos szállítás",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30 napos szállítás + ingyenes tárolódoboz",
      "Lieferung jeden": "Szállítás minden",
      "Monat": "hónapban",
      "SPARE 10%": "SPÓROLJ 10%-OT",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Hogy lovad folyamatosan el legyen látva: szállítás minden hónapban 10% kedvezménnyel. Bármikor szüneteltethető vagy módosítható. Ráadásul INGYEN megkapod a tárolódobozunkat."
    },
    it: {
      "30-Tage-Lieferung": "Consegna ogni 30 giorni",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "Consegna ogni 30 giorni + Contenitore gratuito",
      "Lieferung jeden": "Consegna ogni",
      "Monat": "mese",
      "SPARE 10%": "RISPARMIA IL 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Per garantire al tuo cavallo un supporto continuo: consegna ogni mese con il 10% di sconto. Sospendibile o modificabile in qualsiasi momento. In più, ricevi GRATIS il nostro contenitore."
    },
    lt: {
      "30-Tage-Lieferung": "30 dienų pristatymas",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30 dienų pristatymas + nemokama laikymo dėžutė",
      "Lieferung jeden": "Pristatymas kiekvieną",
      "Monat": "mėnesį",
      "SPARE 10%": "SUTAUPYKITE 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Kad Jūsų žirgas būtų nuolat aprūpintas: pristatymas kiekvieną mėnesį su 10 % nuolaida. Bet kada galite pristabdyti arba pakoreguoti. Be to, NEMOKAMAI gausite mūsų laikymo indelį."
    },
    lv: {
      "30-Tage-Lieferung": "30 dienu piegāde",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30 dienu piegāde + bezmaksas uzglabāšanas kārba",
      "Lieferung jeden": "Piegāde katru",
      "Monat": "mēnesi",
      "SPARE 10%": "IETAUPIET 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Lai jūsu zirgs būtu vienmēr nodrošināts: piegāde katru mēnesi ar 10% atlaidi. Jebkurā laikā apturama vai pielāgojama. Papildus BEZMAKSAS saņemsiet mūsu uzglabāšanas kārbu."
    },
    nl: {
      "30-Tage-Lieferung": "30-daagse levering",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-daagse levering + gratis bewaardoos",
      "Lieferung jeden": "Levering elke",
      "Monat": "maand",
      "SPARE 10%": "BESPAAR 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Zodat je paard altijd voorzien is: levering elke maand met 10% korting. Altijd te pauzeren of aan te passen. Daarnaast ontvang je GRATIS onze bewaardoos."
    },
    pl: {
      "30-Tage-Lieferung": "30-dniowa dostawa",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-dniowa dostawa + darmowy pojemnik do przechowywania",
      "Lieferung jeden": "Dostawa co",
      "Monat": "miesiąc",
      "SPARE 10%": "OSZCZĘDŹ 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Aby zapewnić Twojemu koniowi stały zapas: dostawa co miesiąc z 10% rabatem. Możesz ją w dowolnej chwili wstrzymać lub dostosować. Dodatkowo otrzymujesz GRATIS nasz pojemnik do przechowywania."
    },
    pt: {
      "30-Tage-Lieferung": "Entrega de 30 dias",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "Entrega de 30 dias + Caixa de armazenamento grátis",
      "Lieferung jeden": "Entrega a cada",
      "Monat": "mês",
      "SPARE 10%": "POUPE 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Para garantir o fornecimento contínuo ao seu cavalo: entrega todos os meses com 10% de desconto. Pode ser pausada ou ajustada a qualquer momento. Além disso, recebe GRÁTIS a nossa caixa de armazenamento."
    },
    ro: {
      "30-Tage-Lieferung": "Livrare la 30 de zile",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "Livrare la 30 de zile + cutie de depozitare gratuită",
      "Lieferung jeden": "Livrare în fiecare",
      "Monat": "lună",
      "SPARE 10%": "ECONOMISEȘTE 10%",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Pentru a-i asigura calului tău necesarul pe termen lung: livrare în fiecare lună cu 10% reducere. Poate fi pus pe pauză sau modificat oricând. În plus, primești GRATUIT cutia noastră de depozitare."
    },
    sk: {
      "30-Tage-Lieferung": "30-dňové doručenie",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-dňové doručenie + úložná dóza zadarmo",
      "Lieferung jeden": "Doručenie každý",
      "Monat": "mesiac",
      "SPARE 10%": "UŠETRITE 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Aby mal váš kôň zabezpečený neustály prísun: doručenie každý mesiac s 10 % zľavou. Predplatné môžete kedykoľvek pozastaviť alebo upraviť. K tomu dostanete ZDARMA našu dózu na uskladnenie."
    },
    sl: {
      "30-Tage-Lieferung": "30-dnevna dostava",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-dnevna dostava + brezplačna posoda za shranjevanje",
      "Lieferung jeden": "Dostava vsak",
      "Monat": "mesec",
      "SPARE 10%": "PRIHRANITE 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "Da bo vaš konj trajno preskrbljen: dostava vsak mesec z 10 % popusta. Naročnino lahko kadar koli začasno ustavite ali prilagodite. Zraven BREZPLAČNO dobite našo posodo za shranjevanje."
    },
    sv: {
      "30-Tage-Lieferung": "30-dagarsleverans",
      "30-Tage-Lieferung + Gratis Aufbewahrungsdose": "30-dagarsleverans + gratis förvaringsburk",
      "Lieferung jeden": "Leverans varje",
      "Monat": "månad",
      "SPARE 10%": "SPARA 10 %",
      "Damit dein Pferd dauerhaft versorgt ist: Lieferung jeden Monat mit 10% Rabatt. Jederzeit pausierbar oder anpassbar. Dazu bekommst du GRATIS unsere Aufbewahrungsdose.": "För att din häst alltid ska vara välförsedd: leverans varje månad med 10 % rabatt. Kan pausas eller anpassas när som helst. Dessutom får du vår förvaringsburk GRATIS."
    }
  };

  // Containers Seal renders the translatable text inside. We only walk text nodes
  // within these, so unrelated page text is never touched.
  var CONTAINER_SELECTOR = ".sls-label-container";

  function baseLocale() {
    var l = (window.Shopify && Shopify.locale) ? String(Shopify.locale) : "";
    return l.toLowerCase().split("-")[0];
  }

  var locale = baseLocale();
  if (locale === "de") {
    return; // German is the source — leave as-is.
  }
  // Use the locale's dictionary, or fall back to English (missing/unsupported locale).
  var dict = TRANSLATIONS[locale] || TRANSLATIONS.en;

  // Normalise a string for dictionary lookup: non-breaking spaces -> spaces, trim.
  function normalize(s) {
    return s.replace(/ /g, " ").trim();
  }

  function translate(text) {
    var key = normalize(text);
    return Object.prototype.hasOwnProperty.call(dict, key) ? dict[key] : null;
  }

  // Replace a text node's content while preserving its leading/trailing whitespace
  // (Seal uses &nbsp; for spacing before the savings badge).
  function translateTextNode(node) {
    var raw = node.nodeValue;
    if (!raw || !raw.trim()) {
      return;
    }
    var translated = translate(raw);
    if (translated === null) {
      return;
    }
    var lead = raw.match(/^\s*/)[0];
    var trail = raw.match(/\s*$/)[0];
    var next = lead + translated + trail;
    if (next !== raw) {
      node.nodeValue = next;
    }
  }

  function walk(root) {
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = tw.nextNode())) {
      nodes.push(n);
    }
    nodes.forEach(translateTextNode);
  }

  function translateAll() {
    var containers = document.querySelectorAll(CONTAINER_SELECTOR);
    for (var i = 0; i < containers.length; i++) {
      walk(containers[i]);
    }
  }

  // Run now in case the widget is already present, then keep watching: Seal loads
  // late and re-renders when the interval <select> changes. Re-running is safe —
  // already-translated text no longer matches a German key, so it is left alone.
  var scheduled = false;
  function schedule() {
    if (scheduled) {
      return;
    }
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      translateAll();
    }, 0);
  }

  function start() {
    translateAll();
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
